import BossModel from "@/models/BossModel";
import Customer from '@/models/Customer/Customer';

export default class Relative extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'customer/relative';

    /**
     *
     * @type {string}
     */
    static entity = 'relatives';

    static fields() {
		return {
			id: this.attr(null),
			customer_id: this.number(null).nullable(),
			name: this.attr(null),
			telephone: this.attr(null),
			telephone_additional: this.attr(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
            customer: this.belongsTo(Customer, 'customer_id'),
		}
	}

    /**
     *
     * @param customerId
     * @returns {*}
     */
    static fetchByCustomer(customerId) {
        return this.api()
            .limit(0)
            .where('customer_id', customerId)
            .get(true);
    }

    /**
     *
     * @returns {boolean|*}
     */
    Customer() {
        return this.getRelated('customer');
    }
}
